import signup from "../../../../assets/images/main/startguide/signup.png"
import signupEn from "../../../../assets/images/main/startguide/signup_en.png"
import myPage from "../../../../assets/images/main/startguide/mypage.png"
import myPageEn from "../../../../assets/images/main/startguide/mypage_en.png"
import voucherPurchase from "../../../../assets/images/main/startguide/voucher_purchase.png"
import voucherPurchaseEn from "../../../../assets/images/main/startguide/voucher_purchase_en.png"
import download from "../../../../assets/images/main/startguide/download.png"
import downloadEn from "../../../../assets/images/main/startguide/download_en.png"
import login from "../../../../assets/images/main/startguide/login.png"
import loginEn from "../../../../assets/images/main/startguide/login_en.png"
import game from "../../../../assets/images/main/startguide/pickchildren.png"
import gameEn from "../../../../assets/images/main/startguide/pickchildren_en.png"
import result from "../../../../assets/images/main/startguide/result.png"
import resultEn from "../../../../assets/images/main/startguide/result_en.png"

import code from "../../../../assets/images/main/startguide/organ_code.svg"
import codeEn from "../../../../assets/images/main/startguide/organ_code_en.png"
import organDownload from "../../../../assets/images/main/startguide/organ_download.png"
import organDownloadEn from "../../../../assets/images/main/startguide/organ_download_en.png"
import organLogin from "../../../../assets/images/main/startguide/organ_login.png"
import organLoginEn from "../../../../assets/images/main/startguide/organ_login_en.png"
import processing from "../../../../assets/images/main/startguide/organ_processing.png"
import processingEn from "../../../../assets/images/main/startguide/organ_processing_en.png"
import organResult from "../../../../assets/images/main/startguide/organ_result.png"
import organResultEn from "../../../../assets/images/main/startguide/organ_result_en.png"
import {GroupMemberItemType, GuideType, MemberItemType} from "../../../../types/startGuide";

export function useStartGuideFunctions() {
    const GUIDE_IMAGES = {
        [GuideType.MEMBERS] :{
            [MemberItemType.SIGNUP]: {
                ko: signup,
                en: signupEn
            },
            [MemberItemType.MYPAGE]: {
                ko: myPage,
                en: myPageEn
            },
            [MemberItemType.VOUCHER_PURCHASE]: {
                ko: voucherPurchase,
                en: voucherPurchaseEn
            },
            [MemberItemType.DOWNLOAD]: {
                ko: download,
                en: downloadEn
            },
            [MemberItemType.LOGIN]: {
                ko: login,
                en: loginEn
            },
            [MemberItemType.GAME]: {
                ko: game,
                en: gameEn
            },
            [MemberItemType.RESULT]: {
                ko: result,
                en: resultEn
            }
        },
        [GuideType.GROUP_MEMBERS]:{
            [GroupMemberItemType.CODE]: {
                ko: code,
                en: codeEn
            },
            [GroupMemberItemType.DOWNLOAD]: {
                ko: organDownload,
                en: organDownloadEn
            },
            [GroupMemberItemType.LOGIN]: {
                ko: organLogin,
                en: organLoginEn
            },
            [GroupMemberItemType.PROCESSING]: {
                ko: processing,
                en: processingEn
            },
            [GroupMemberItemType.RESULT]: {
                ko: organResult,
                en: organResultEn
            },
        }
    };

// 이미지 선택 함수
    function getImageByLanguage(
        memberType: GuideType,
        isKorean: boolean ,
        imageKey: MemberItemType | GroupMemberItemType
    ) {
        const lang = isKorean ? 'ko' : 'en';

        return (GUIDE_IMAGES as any)[memberType][imageKey][lang];
    }
    return{
        getImageByLanguage
    }
}